// extracted by mini-css-extract-plugin
export default {"horizontal":"Divider_horizontal__hpYst","vertical":"Divider_vertical__BGIIs"};